/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createLLMProject = /* GraphQL */ `mutation CreateLLMProject(
  $input: CreateLLMProjectInput!
  $condition: ModelLLMProjectConditionInput
) {
  createLLMProject(input: $input, condition: $condition) {
    id
    name
    status
    description
    users {
      items {
        id
        email
        status
        displayName
        acceptedTermsOfService
        acceptedGDPRTerms
        projectId
        project {
          id
          name
          status
          description
          stripeCustomerId
          newCustomerTokenCount
          cacheResponsesForSeconds
          loadSheddingTier
          newCustomerLoadSheddingTier
          maintenanceMode
          maintenanceModeMessage
          loadBalancingMode
          piiRedactionScope
          systemInstructions
          piiScope
          piiGroupId
          piiMessage
          promptBlacklist
          blacklistGroupId
          blacklistMessage
          safety
          safetyGroupId
          safetyMessage
          strongModelGroupId
          routeModel
          trialTokensRemaining
          logfileRetentionPeriod
          callRetentionPeriod
          logInterval
          lastLogGeneratedAt
          enterpriseAllowChat
          enterpriseAcceptableUsePolicy
          enterpriseAccessRequestEmail
          enterpriseSupportEmail
          enterpriseDomainWhitelist
          enterpriseTokenBudget
          enterpriseTokenBudgetPeriod
          enterpriseImageUrl
          randomGroup
          apiCreditRemaining
          createdAt
          summaryEmailPeriod
          summaryEmailAddresses
          lastSummaryEmailSentAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    services {
      items {
        id
        name
        status
        vendor
        region
        endpoint
        body
        header
        projectId
        loadProportion
        inputTokenPricePerMillion
        outputTokenPricePerMillion
        groupId
        group {
          id
          status
          name
          description
          projectId
          systemInstructions
          systemInstructionsAction
          order
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    stripeCustomerId
    subscription {
      id
      projectId
      quantity
      subscriptionId
      subscriptionStartDate
      subscriptionEndDate
      subscriptionStatus
      subscriptionProduct
      subscriptionInterval
      subscriptionEndedAt
      subscriptionCancelAtPeriodEnd
      usageSubscriptionId
      createdAt
      updatedAt
      __typename
    }
    newCustomerTokenCount
    cacheResponsesForSeconds
    loadSheddingTier
    newCustomerLoadSheddingTier
    maintenanceMode
    maintenanceModeMessage
    loadBalancingMode
    piiRedactionScope
    systemInstructions
    piiScope
    piiGroupId
    piiMessage
    promptBlacklist
    blacklistGroupId
    blacklistMessage
    safety
    safetyGroupId
    safetyMessage
    strongModelGroupId
    routeModel
    trialTokensRemaining
    logfileRetentionPeriod
    callRetentionPeriod
    logInterval
    lastLogGeneratedAt
    enterpriseAllowChat
    enterpriseAcceptableUsePolicy
    enterpriseAccessRequestEmail
    enterpriseSupportEmail
    enterpriseDomainWhitelist
    enterpriseTokenBudget
    enterpriseTokenBudgetPeriod
    enterpriseImageUrl
    randomGroup
    apiCreditRemaining
    createdAt
    summaryEmailPeriod
    summaryEmailAddresses
    lastSummaryEmailSentAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMProjectMutationVariables,
  APITypes.CreateLLMProjectMutation
>;
export const updateLLMProject = /* GraphQL */ `mutation UpdateLLMProject(
  $input: UpdateLLMProjectInput!
  $condition: ModelLLMProjectConditionInput
) {
  updateLLMProject(input: $input, condition: $condition) {
    id
    name
    status
    description
    users {
      items {
        id
        email
        status
        displayName
        acceptedTermsOfService
        acceptedGDPRTerms
        projectId
        project {
          id
          name
          status
          description
          stripeCustomerId
          newCustomerTokenCount
          cacheResponsesForSeconds
          loadSheddingTier
          newCustomerLoadSheddingTier
          maintenanceMode
          maintenanceModeMessage
          loadBalancingMode
          piiRedactionScope
          systemInstructions
          piiScope
          piiGroupId
          piiMessage
          promptBlacklist
          blacklistGroupId
          blacklistMessage
          safety
          safetyGroupId
          safetyMessage
          strongModelGroupId
          routeModel
          trialTokensRemaining
          logfileRetentionPeriod
          callRetentionPeriod
          logInterval
          lastLogGeneratedAt
          enterpriseAllowChat
          enterpriseAcceptableUsePolicy
          enterpriseAccessRequestEmail
          enterpriseSupportEmail
          enterpriseDomainWhitelist
          enterpriseTokenBudget
          enterpriseTokenBudgetPeriod
          enterpriseImageUrl
          randomGroup
          apiCreditRemaining
          createdAt
          summaryEmailPeriod
          summaryEmailAddresses
          lastSummaryEmailSentAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    services {
      items {
        id
        name
        status
        vendor
        region
        endpoint
        body
        header
        projectId
        loadProportion
        inputTokenPricePerMillion
        outputTokenPricePerMillion
        groupId
        group {
          id
          status
          name
          description
          projectId
          systemInstructions
          systemInstructionsAction
          order
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    stripeCustomerId
    subscription {
      id
      projectId
      quantity
      subscriptionId
      subscriptionStartDate
      subscriptionEndDate
      subscriptionStatus
      subscriptionProduct
      subscriptionInterval
      subscriptionEndedAt
      subscriptionCancelAtPeriodEnd
      usageSubscriptionId
      createdAt
      updatedAt
      __typename
    }
    newCustomerTokenCount
    cacheResponsesForSeconds
    loadSheddingTier
    newCustomerLoadSheddingTier
    maintenanceMode
    maintenanceModeMessage
    loadBalancingMode
    piiRedactionScope
    systemInstructions
    piiScope
    piiGroupId
    piiMessage
    promptBlacklist
    blacklistGroupId
    blacklistMessage
    safety
    safetyGroupId
    safetyMessage
    strongModelGroupId
    routeModel
    trialTokensRemaining
    logfileRetentionPeriod
    callRetentionPeriod
    logInterval
    lastLogGeneratedAt
    enterpriseAllowChat
    enterpriseAcceptableUsePolicy
    enterpriseAccessRequestEmail
    enterpriseSupportEmail
    enterpriseDomainWhitelist
    enterpriseTokenBudget
    enterpriseTokenBudgetPeriod
    enterpriseImageUrl
    randomGroup
    apiCreditRemaining
    createdAt
    summaryEmailPeriod
    summaryEmailAddresses
    lastSummaryEmailSentAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMProjectMutationVariables,
  APITypes.UpdateLLMProjectMutation
>;
export const deleteLLMProject = /* GraphQL */ `mutation DeleteLLMProject(
  $input: DeleteLLMProjectInput!
  $condition: ModelLLMProjectConditionInput
) {
  deleteLLMProject(input: $input, condition: $condition) {
    id
    name
    status
    description
    users {
      items {
        id
        email
        status
        displayName
        acceptedTermsOfService
        acceptedGDPRTerms
        projectId
        project {
          id
          name
          status
          description
          stripeCustomerId
          newCustomerTokenCount
          cacheResponsesForSeconds
          loadSheddingTier
          newCustomerLoadSheddingTier
          maintenanceMode
          maintenanceModeMessage
          loadBalancingMode
          piiRedactionScope
          systemInstructions
          piiScope
          piiGroupId
          piiMessage
          promptBlacklist
          blacklistGroupId
          blacklistMessage
          safety
          safetyGroupId
          safetyMessage
          strongModelGroupId
          routeModel
          trialTokensRemaining
          logfileRetentionPeriod
          callRetentionPeriod
          logInterval
          lastLogGeneratedAt
          enterpriseAllowChat
          enterpriseAcceptableUsePolicy
          enterpriseAccessRequestEmail
          enterpriseSupportEmail
          enterpriseDomainWhitelist
          enterpriseTokenBudget
          enterpriseTokenBudgetPeriod
          enterpriseImageUrl
          randomGroup
          apiCreditRemaining
          createdAt
          summaryEmailPeriod
          summaryEmailAddresses
          lastSummaryEmailSentAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    services {
      items {
        id
        name
        status
        vendor
        region
        endpoint
        body
        header
        projectId
        loadProportion
        inputTokenPricePerMillion
        outputTokenPricePerMillion
        groupId
        group {
          id
          status
          name
          description
          projectId
          systemInstructions
          systemInstructionsAction
          order
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    stripeCustomerId
    subscription {
      id
      projectId
      quantity
      subscriptionId
      subscriptionStartDate
      subscriptionEndDate
      subscriptionStatus
      subscriptionProduct
      subscriptionInterval
      subscriptionEndedAt
      subscriptionCancelAtPeriodEnd
      usageSubscriptionId
      createdAt
      updatedAt
      __typename
    }
    newCustomerTokenCount
    cacheResponsesForSeconds
    loadSheddingTier
    newCustomerLoadSheddingTier
    maintenanceMode
    maintenanceModeMessage
    loadBalancingMode
    piiRedactionScope
    systemInstructions
    piiScope
    piiGroupId
    piiMessage
    promptBlacklist
    blacklistGroupId
    blacklistMessage
    safety
    safetyGroupId
    safetyMessage
    strongModelGroupId
    routeModel
    trialTokensRemaining
    logfileRetentionPeriod
    callRetentionPeriod
    logInterval
    lastLogGeneratedAt
    enterpriseAllowChat
    enterpriseAcceptableUsePolicy
    enterpriseAccessRequestEmail
    enterpriseSupportEmail
    enterpriseDomainWhitelist
    enterpriseTokenBudget
    enterpriseTokenBudgetPeriod
    enterpriseImageUrl
    randomGroup
    apiCreditRemaining
    createdAt
    summaryEmailPeriod
    summaryEmailAddresses
    lastSummaryEmailSentAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMProjectMutationVariables,
  APITypes.DeleteLLMProjectMutation
>;
export const createLLMProjectSubscription = /* GraphQL */ `mutation CreateLLMProjectSubscription(
  $input: CreateLLMProjectSubscriptionInput!
  $condition: ModelLLMProjectSubscriptionConditionInput
) {
  createLLMProjectSubscription(input: $input, condition: $condition) {
    id
    projectId
    quantity
    subscriptionId
    subscriptionStartDate
    subscriptionEndDate
    subscriptionStatus
    subscriptionProduct
    subscriptionInterval
    subscriptionEndedAt
    subscriptionCancelAtPeriodEnd
    usageSubscriptionId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMProjectSubscriptionMutationVariables,
  APITypes.CreateLLMProjectSubscriptionMutation
>;
export const updateLLMProjectSubscription = /* GraphQL */ `mutation UpdateLLMProjectSubscription(
  $input: UpdateLLMProjectSubscriptionInput!
  $condition: ModelLLMProjectSubscriptionConditionInput
) {
  updateLLMProjectSubscription(input: $input, condition: $condition) {
    id
    projectId
    quantity
    subscriptionId
    subscriptionStartDate
    subscriptionEndDate
    subscriptionStatus
    subscriptionProduct
    subscriptionInterval
    subscriptionEndedAt
    subscriptionCancelAtPeriodEnd
    usageSubscriptionId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMProjectSubscriptionMutationVariables,
  APITypes.UpdateLLMProjectSubscriptionMutation
>;
export const deleteLLMProjectSubscription = /* GraphQL */ `mutation DeleteLLMProjectSubscription(
  $input: DeleteLLMProjectSubscriptionInput!
  $condition: ModelLLMProjectSubscriptionConditionInput
) {
  deleteLLMProjectSubscription(input: $input, condition: $condition) {
    id
    projectId
    quantity
    subscriptionId
    subscriptionStartDate
    subscriptionEndDate
    subscriptionStatus
    subscriptionProduct
    subscriptionInterval
    subscriptionEndedAt
    subscriptionCancelAtPeriodEnd
    usageSubscriptionId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMProjectSubscriptionMutationVariables,
  APITypes.DeleteLLMProjectSubscriptionMutation
>;
export const createLLMUser = /* GraphQL */ `mutation CreateLLMUser(
  $input: CreateLLMUserInput!
  $condition: ModelLLMUserConditionInput
) {
  createLLMUser(input: $input, condition: $condition) {
    id
    email
    status
    displayName
    acceptedTermsOfService
    acceptedGDPRTerms
    projectId
    project {
      id
      name
      status
      description
      users {
        items {
          id
          email
          status
          displayName
          acceptedTermsOfService
          acceptedGDPRTerms
          projectId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      services {
        items {
          id
          name
          status
          vendor
          region
          endpoint
          body
          header
          projectId
          loadProportion
          inputTokenPricePerMillion
          outputTokenPricePerMillion
          groupId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      stripeCustomerId
      subscription {
        id
        projectId
        quantity
        subscriptionId
        subscriptionStartDate
        subscriptionEndDate
        subscriptionStatus
        subscriptionProduct
        subscriptionInterval
        subscriptionEndedAt
        subscriptionCancelAtPeriodEnd
        usageSubscriptionId
        createdAt
        updatedAt
        __typename
      }
      newCustomerTokenCount
      cacheResponsesForSeconds
      loadSheddingTier
      newCustomerLoadSheddingTier
      maintenanceMode
      maintenanceModeMessage
      loadBalancingMode
      piiRedactionScope
      systemInstructions
      piiScope
      piiGroupId
      piiMessage
      promptBlacklist
      blacklistGroupId
      blacklistMessage
      safety
      safetyGroupId
      safetyMessage
      strongModelGroupId
      routeModel
      trialTokensRemaining
      logfileRetentionPeriod
      callRetentionPeriod
      logInterval
      lastLogGeneratedAt
      enterpriseAllowChat
      enterpriseAcceptableUsePolicy
      enterpriseAccessRequestEmail
      enterpriseSupportEmail
      enterpriseDomainWhitelist
      enterpriseTokenBudget
      enterpriseTokenBudgetPeriod
      enterpriseImageUrl
      randomGroup
      apiCreditRemaining
      createdAt
      summaryEmailPeriod
      summaryEmailAddresses
      lastSummaryEmailSentAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMUserMutationVariables,
  APITypes.CreateLLMUserMutation
>;
export const updateLLMUser = /* GraphQL */ `mutation UpdateLLMUser(
  $input: UpdateLLMUserInput!
  $condition: ModelLLMUserConditionInput
) {
  updateLLMUser(input: $input, condition: $condition) {
    id
    email
    status
    displayName
    acceptedTermsOfService
    acceptedGDPRTerms
    projectId
    project {
      id
      name
      status
      description
      users {
        items {
          id
          email
          status
          displayName
          acceptedTermsOfService
          acceptedGDPRTerms
          projectId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      services {
        items {
          id
          name
          status
          vendor
          region
          endpoint
          body
          header
          projectId
          loadProportion
          inputTokenPricePerMillion
          outputTokenPricePerMillion
          groupId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      stripeCustomerId
      subscription {
        id
        projectId
        quantity
        subscriptionId
        subscriptionStartDate
        subscriptionEndDate
        subscriptionStatus
        subscriptionProduct
        subscriptionInterval
        subscriptionEndedAt
        subscriptionCancelAtPeriodEnd
        usageSubscriptionId
        createdAt
        updatedAt
        __typename
      }
      newCustomerTokenCount
      cacheResponsesForSeconds
      loadSheddingTier
      newCustomerLoadSheddingTier
      maintenanceMode
      maintenanceModeMessage
      loadBalancingMode
      piiRedactionScope
      systemInstructions
      piiScope
      piiGroupId
      piiMessage
      promptBlacklist
      blacklistGroupId
      blacklistMessage
      safety
      safetyGroupId
      safetyMessage
      strongModelGroupId
      routeModel
      trialTokensRemaining
      logfileRetentionPeriod
      callRetentionPeriod
      logInterval
      lastLogGeneratedAt
      enterpriseAllowChat
      enterpriseAcceptableUsePolicy
      enterpriseAccessRequestEmail
      enterpriseSupportEmail
      enterpriseDomainWhitelist
      enterpriseTokenBudget
      enterpriseTokenBudgetPeriod
      enterpriseImageUrl
      randomGroup
      apiCreditRemaining
      createdAt
      summaryEmailPeriod
      summaryEmailAddresses
      lastSummaryEmailSentAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMUserMutationVariables,
  APITypes.UpdateLLMUserMutation
>;
export const deleteLLMUser = /* GraphQL */ `mutation DeleteLLMUser(
  $input: DeleteLLMUserInput!
  $condition: ModelLLMUserConditionInput
) {
  deleteLLMUser(input: $input, condition: $condition) {
    id
    email
    status
    displayName
    acceptedTermsOfService
    acceptedGDPRTerms
    projectId
    project {
      id
      name
      status
      description
      users {
        items {
          id
          email
          status
          displayName
          acceptedTermsOfService
          acceptedGDPRTerms
          projectId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      services {
        items {
          id
          name
          status
          vendor
          region
          endpoint
          body
          header
          projectId
          loadProportion
          inputTokenPricePerMillion
          outputTokenPricePerMillion
          groupId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      stripeCustomerId
      subscription {
        id
        projectId
        quantity
        subscriptionId
        subscriptionStartDate
        subscriptionEndDate
        subscriptionStatus
        subscriptionProduct
        subscriptionInterval
        subscriptionEndedAt
        subscriptionCancelAtPeriodEnd
        usageSubscriptionId
        createdAt
        updatedAt
        __typename
      }
      newCustomerTokenCount
      cacheResponsesForSeconds
      loadSheddingTier
      newCustomerLoadSheddingTier
      maintenanceMode
      maintenanceModeMessage
      loadBalancingMode
      piiRedactionScope
      systemInstructions
      piiScope
      piiGroupId
      piiMessage
      promptBlacklist
      blacklistGroupId
      blacklistMessage
      safety
      safetyGroupId
      safetyMessage
      strongModelGroupId
      routeModel
      trialTokensRemaining
      logfileRetentionPeriod
      callRetentionPeriod
      logInterval
      lastLogGeneratedAt
      enterpriseAllowChat
      enterpriseAcceptableUsePolicy
      enterpriseAccessRequestEmail
      enterpriseSupportEmail
      enterpriseDomainWhitelist
      enterpriseTokenBudget
      enterpriseTokenBudgetPeriod
      enterpriseImageUrl
      randomGroup
      apiCreditRemaining
      createdAt
      summaryEmailPeriod
      summaryEmailAddresses
      lastSummaryEmailSentAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMUserMutationVariables,
  APITypes.DeleteLLMUserMutation
>;
export const createLLMService = /* GraphQL */ `mutation CreateLLMService(
  $input: CreateLLMServiceInput!
  $condition: ModelLLMServiceConditionInput
) {
  createLLMService(input: $input, condition: $condition) {
    id
    name
    status
    vendor
    region
    endpoint
    body
    header
    projectId
    loadProportion
    inputTokenPricePerMillion
    outputTokenPricePerMillion
    groupId
    group {
      id
      status
      name
      description
      projectId
      systemInstructions
      systemInstructionsAction
      order
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMServiceMutationVariables,
  APITypes.CreateLLMServiceMutation
>;
export const updateLLMService = /* GraphQL */ `mutation UpdateLLMService(
  $input: UpdateLLMServiceInput!
  $condition: ModelLLMServiceConditionInput
) {
  updateLLMService(input: $input, condition: $condition) {
    id
    name
    status
    vendor
    region
    endpoint
    body
    header
    projectId
    loadProportion
    inputTokenPricePerMillion
    outputTokenPricePerMillion
    groupId
    group {
      id
      status
      name
      description
      projectId
      systemInstructions
      systemInstructionsAction
      order
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMServiceMutationVariables,
  APITypes.UpdateLLMServiceMutation
>;
export const deleteLLMService = /* GraphQL */ `mutation DeleteLLMService(
  $input: DeleteLLMServiceInput!
  $condition: ModelLLMServiceConditionInput
) {
  deleteLLMService(input: $input, condition: $condition) {
    id
    name
    status
    vendor
    region
    endpoint
    body
    header
    projectId
    loadProportion
    inputTokenPricePerMillion
    outputTokenPricePerMillion
    groupId
    group {
      id
      status
      name
      description
      projectId
      systemInstructions
      systemInstructionsAction
      order
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMServiceMutationVariables,
  APITypes.DeleteLLMServiceMutation
>;
export const createLLMGroup = /* GraphQL */ `mutation CreateLLMGroup(
  $input: CreateLLMGroupInput!
  $condition: ModelLLMGroupConditionInput
) {
  createLLMGroup(input: $input, condition: $condition) {
    id
    status
    name
    description
    projectId
    systemInstructions
    systemInstructionsAction
    order
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMGroupMutationVariables,
  APITypes.CreateLLMGroupMutation
>;
export const updateLLMGroup = /* GraphQL */ `mutation UpdateLLMGroup(
  $input: UpdateLLMGroupInput!
  $condition: ModelLLMGroupConditionInput
) {
  updateLLMGroup(input: $input, condition: $condition) {
    id
    status
    name
    description
    projectId
    systemInstructions
    systemInstructionsAction
    order
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMGroupMutationVariables,
  APITypes.UpdateLLMGroupMutation
>;
export const deleteLLMGroup = /* GraphQL */ `mutation DeleteLLMGroup(
  $input: DeleteLLMGroupInput!
  $condition: ModelLLMGroupConditionInput
) {
  deleteLLMGroup(input: $input, condition: $condition) {
    id
    status
    name
    description
    projectId
    systemInstructions
    systemInstructionsAction
    order
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMGroupMutationVariables,
  APITypes.DeleteLLMGroupMutation
>;
export const createLLMRouteRule = /* GraphQL */ `mutation CreateLLMRouteRule(
  $input: CreateLLMRouteRuleInput!
  $condition: ModelLLMRouteRuleConditionInput
) {
  createLLMRouteRule(input: $input, condition: $condition) {
    id
    status
    projectId
    name
    pattern
    patternAction
    threshold
    thresholdAction
    groupId
    group {
      id
      status
      name
      description
      projectId
      systemInstructions
      systemInstructionsAction
      order
      createdAt
      updatedAt
      __typename
    }
    order
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMRouteRuleMutationVariables,
  APITypes.CreateLLMRouteRuleMutation
>;
export const updateLLMRouteRule = /* GraphQL */ `mutation UpdateLLMRouteRule(
  $input: UpdateLLMRouteRuleInput!
  $condition: ModelLLMRouteRuleConditionInput
) {
  updateLLMRouteRule(input: $input, condition: $condition) {
    id
    status
    projectId
    name
    pattern
    patternAction
    threshold
    thresholdAction
    groupId
    group {
      id
      status
      name
      description
      projectId
      systemInstructions
      systemInstructionsAction
      order
      createdAt
      updatedAt
      __typename
    }
    order
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMRouteRuleMutationVariables,
  APITypes.UpdateLLMRouteRuleMutation
>;
export const deleteLLMRouteRule = /* GraphQL */ `mutation DeleteLLMRouteRule(
  $input: DeleteLLMRouteRuleInput!
  $condition: ModelLLMRouteRuleConditionInput
) {
  deleteLLMRouteRule(input: $input, condition: $condition) {
    id
    status
    projectId
    name
    pattern
    patternAction
    threshold
    thresholdAction
    groupId
    group {
      id
      status
      name
      description
      projectId
      systemInstructions
      systemInstructionsAction
      order
      createdAt
      updatedAt
      __typename
    }
    order
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMRouteRuleMutationVariables,
  APITypes.DeleteLLMRouteRuleMutation
>;
export const createLLMCustomer = /* GraphQL */ `mutation CreateLLMCustomer(
  $input: CreateLLMCustomerInput!
  $condition: ModelLLMCustomerConditionInput
) {
  createLLMCustomer(input: $input, condition: $condition) {
    id
    name
    status
    tokensRemaining
    lastCallMadeAt
    numberOfCallsMade
    projectId
    loadSheddingTier
    dataResidency
    createdAt
    enterpriseUser
    tokenReplenishmentAmount
    tokenReplenishmentPeriod
    lastReplenishedAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMCustomerMutationVariables,
  APITypes.CreateLLMCustomerMutation
>;
export const updateLLMCustomer = /* GraphQL */ `mutation UpdateLLMCustomer(
  $input: UpdateLLMCustomerInput!
  $condition: ModelLLMCustomerConditionInput
) {
  updateLLMCustomer(input: $input, condition: $condition) {
    id
    name
    status
    tokensRemaining
    lastCallMadeAt
    numberOfCallsMade
    projectId
    loadSheddingTier
    dataResidency
    createdAt
    enterpriseUser
    tokenReplenishmentAmount
    tokenReplenishmentPeriod
    lastReplenishedAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMCustomerMutationVariables,
  APITypes.UpdateLLMCustomerMutation
>;
export const deleteLLMCustomer = /* GraphQL */ `mutation DeleteLLMCustomer(
  $input: DeleteLLMCustomerInput!
  $condition: ModelLLMCustomerConditionInput
) {
  deleteLLMCustomer(input: $input, condition: $condition) {
    id
    name
    status
    tokensRemaining
    lastCallMadeAt
    numberOfCallsMade
    projectId
    loadSheddingTier
    dataResidency
    createdAt
    enterpriseUser
    tokenReplenishmentAmount
    tokenReplenishmentPeriod
    lastReplenishedAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMCustomerMutationVariables,
  APITypes.DeleteLLMCustomerMutation
>;
export const createLLMCall = /* GraphQL */ `mutation CreateLLMCall(
  $input: CreateLLMCallInput!
  $condition: ModelLLMCallConditionInput
) {
  createLLMCall(input: $input, condition: $condition) {
    id
    projectId
    status
    customerId
    customer {
      id
      name
      status
      tokensRemaining
      lastCallMadeAt
      numberOfCallsMade
      projectId
      loadSheddingTier
      dataResidency
      createdAt
      enterpriseUser
      tokenReplenishmentAmount
      tokenReplenishmentPeriod
      lastReplenishedAt
      updatedAt
      __typename
    }
    serviceId
    service {
      id
      name
      status
      vendor
      region
      endpoint
      body
      header
      projectId
      loadProportion
      inputTokenPricePerMillion
      outputTokenPricePerMillion
      groupId
      group {
        id
        status
        name
        description
        projectId
        systemInstructions
        systemInstructionsAction
        order
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    requestHash
    messages
    prompt
    response
    tokenCountPrompt
    tokenCountResponse
    createdAt
    hash
    country
    region
    city
    quality
    qualityComment
    apiKeyType
    toxicity
    randomGroup
    agentId
    conversationId
    timings
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMCallMutationVariables,
  APITypes.CreateLLMCallMutation
>;
export const updateLLMCall = /* GraphQL */ `mutation UpdateLLMCall(
  $input: UpdateLLMCallInput!
  $condition: ModelLLMCallConditionInput
) {
  updateLLMCall(input: $input, condition: $condition) {
    id
    projectId
    status
    customerId
    customer {
      id
      name
      status
      tokensRemaining
      lastCallMadeAt
      numberOfCallsMade
      projectId
      loadSheddingTier
      dataResidency
      createdAt
      enterpriseUser
      tokenReplenishmentAmount
      tokenReplenishmentPeriod
      lastReplenishedAt
      updatedAt
      __typename
    }
    serviceId
    service {
      id
      name
      status
      vendor
      region
      endpoint
      body
      header
      projectId
      loadProportion
      inputTokenPricePerMillion
      outputTokenPricePerMillion
      groupId
      group {
        id
        status
        name
        description
        projectId
        systemInstructions
        systemInstructionsAction
        order
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    requestHash
    messages
    prompt
    response
    tokenCountPrompt
    tokenCountResponse
    createdAt
    hash
    country
    region
    city
    quality
    qualityComment
    apiKeyType
    toxicity
    randomGroup
    agentId
    conversationId
    timings
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMCallMutationVariables,
  APITypes.UpdateLLMCallMutation
>;
export const deleteLLMCall = /* GraphQL */ `mutation DeleteLLMCall(
  $input: DeleteLLMCallInput!
  $condition: ModelLLMCallConditionInput
) {
  deleteLLMCall(input: $input, condition: $condition) {
    id
    projectId
    status
    customerId
    customer {
      id
      name
      status
      tokensRemaining
      lastCallMadeAt
      numberOfCallsMade
      projectId
      loadSheddingTier
      dataResidency
      createdAt
      enterpriseUser
      tokenReplenishmentAmount
      tokenReplenishmentPeriod
      lastReplenishedAt
      updatedAt
      __typename
    }
    serviceId
    service {
      id
      name
      status
      vendor
      region
      endpoint
      body
      header
      projectId
      loadProportion
      inputTokenPricePerMillion
      outputTokenPricePerMillion
      groupId
      group {
        id
        status
        name
        description
        projectId
        systemInstructions
        systemInstructionsAction
        order
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    requestHash
    messages
    prompt
    response
    tokenCountPrompt
    tokenCountResponse
    createdAt
    hash
    country
    region
    city
    quality
    qualityComment
    apiKeyType
    toxicity
    randomGroup
    agentId
    conversationId
    timings
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMCallMutationVariables,
  APITypes.DeleteLLMCallMutation
>;
export const createLLMPrompt = /* GraphQL */ `mutation CreateLLMPrompt(
  $input: CreateLLMPromptInput!
  $condition: ModelLLMPromptConditionInput
) {
  createLLMPrompt(input: $input, condition: $condition) {
    id
    projectId
    status
    name
    description
    prompt
    key
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMPromptMutationVariables,
  APITypes.CreateLLMPromptMutation
>;
export const updateLLMPrompt = /* GraphQL */ `mutation UpdateLLMPrompt(
  $input: UpdateLLMPromptInput!
  $condition: ModelLLMPromptConditionInput
) {
  updateLLMPrompt(input: $input, condition: $condition) {
    id
    projectId
    status
    name
    description
    prompt
    key
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMPromptMutationVariables,
  APITypes.UpdateLLMPromptMutation
>;
export const deleteLLMPrompt = /* GraphQL */ `mutation DeleteLLMPrompt(
  $input: DeleteLLMPromptInput!
  $condition: ModelLLMPromptConditionInput
) {
  deleteLLMPrompt(input: $input, condition: $condition) {
    id
    projectId
    status
    name
    description
    prompt
    key
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMPromptMutationVariables,
  APITypes.DeleteLLMPromptMutation
>;
export const createLLMCallLogFile = /* GraphQL */ `mutation CreateLLMCallLogFile(
  $input: CreateLLMCallLogFileInput!
  $condition: ModelLLMCallLogFileConditionInput
) {
  createLLMCallLogFile(input: $input, condition: $condition) {
    id
    projectId
    fromDate
    toDate
    chunk
    count
    status
    bucket
    key
    url
    urlExpiresAt
    deleteFileAfter
    createdAt
    randomGroup
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMCallLogFileMutationVariables,
  APITypes.CreateLLMCallLogFileMutation
>;
export const updateLLMCallLogFile = /* GraphQL */ `mutation UpdateLLMCallLogFile(
  $input: UpdateLLMCallLogFileInput!
  $condition: ModelLLMCallLogFileConditionInput
) {
  updateLLMCallLogFile(input: $input, condition: $condition) {
    id
    projectId
    fromDate
    toDate
    chunk
    count
    status
    bucket
    key
    url
    urlExpiresAt
    deleteFileAfter
    createdAt
    randomGroup
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMCallLogFileMutationVariables,
  APITypes.UpdateLLMCallLogFileMutation
>;
export const deleteLLMCallLogFile = /* GraphQL */ `mutation DeleteLLMCallLogFile(
  $input: DeleteLLMCallLogFileInput!
  $condition: ModelLLMCallLogFileConditionInput
) {
  deleteLLMCallLogFile(input: $input, condition: $condition) {
    id
    projectId
    fromDate
    toDate
    chunk
    count
    status
    bucket
    key
    url
    urlExpiresAt
    deleteFileAfter
    createdAt
    randomGroup
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMCallLogFileMutationVariables,
  APITypes.DeleteLLMCallLogFileMutation
>;
export const createLLMAgent = /* GraphQL */ `mutation CreateLLMAgent(
  $input: CreateLLMAgentInput!
  $condition: ModelLLMAgentConditionInput
) {
  createLLMAgent(input: $input, condition: $condition) {
    id
    status
    name
    description
    projectId
    systemInstructions
    systemInstructionsAction
    displayTheme
    cssUrl
    displayTitle
    displayStartMessageOrPrompt
    displayInitialMessageOrPrompt
    displayPromptTemplate
    displayFollowOnPrompts
    displayActions
    displayWidth
    displayHeight
    displayPlaceholder
    displayHideInitialPrompt
    displayShowSaveButton
    displayShowEmailButton
    displayShowCallToAction
    displayCallToActionButtonText
    displayCallToActionEmailAddress
    displayCallToActionEmailSubject
    displayCallToActionMustSendEmail
    displayScrollToEnd
    groupId
    data
    calls {
      items {
        id
        projectId
        status
        customerId
        customer {
          id
          name
          status
          tokensRemaining
          lastCallMadeAt
          numberOfCallsMade
          projectId
          loadSheddingTier
          dataResidency
          createdAt
          enterpriseUser
          tokenReplenishmentAmount
          tokenReplenishmentPeriod
          lastReplenishedAt
          updatedAt
          __typename
        }
        serviceId
        service {
          id
          name
          status
          vendor
          region
          endpoint
          body
          header
          projectId
          loadProportion
          inputTokenPricePerMillion
          outputTokenPricePerMillion
          groupId
          createdAt
          updatedAt
          __typename
        }
        requestHash
        messages
        prompt
        response
        tokenCountPrompt
        tokenCountResponse
        createdAt
        hash
        country
        region
        city
        quality
        qualityComment
        apiKeyType
        toxicity
        randomGroup
        agentId
        conversationId
        timings
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    documents {
      items {
        id
        projectId
        agentId
        status
        fileName
        fileSize
        fileType
        uploadDate
        uploader
        lastModifiedDate
        ownershipAttestation
        location
        type
        ragSplitter
        ragChunkSize
        ragChunkOverlap
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    ragQueryLimit
    ragRankLimit
    ragIncludeCitations
    ragDoRerank
    visibility
    createConversationOnFirstChat
    customerEmailCaptureMode
    customerEmailCapturePlaceholder
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMAgentMutationVariables,
  APITypes.CreateLLMAgentMutation
>;
export const updateLLMAgent = /* GraphQL */ `mutation UpdateLLMAgent(
  $input: UpdateLLMAgentInput!
  $condition: ModelLLMAgentConditionInput
) {
  updateLLMAgent(input: $input, condition: $condition) {
    id
    status
    name
    description
    projectId
    systemInstructions
    systemInstructionsAction
    displayTheme
    cssUrl
    displayTitle
    displayStartMessageOrPrompt
    displayInitialMessageOrPrompt
    displayPromptTemplate
    displayFollowOnPrompts
    displayActions
    displayWidth
    displayHeight
    displayPlaceholder
    displayHideInitialPrompt
    displayShowSaveButton
    displayShowEmailButton
    displayShowCallToAction
    displayCallToActionButtonText
    displayCallToActionEmailAddress
    displayCallToActionEmailSubject
    displayCallToActionMustSendEmail
    displayScrollToEnd
    groupId
    data
    calls {
      items {
        id
        projectId
        status
        customerId
        customer {
          id
          name
          status
          tokensRemaining
          lastCallMadeAt
          numberOfCallsMade
          projectId
          loadSheddingTier
          dataResidency
          createdAt
          enterpriseUser
          tokenReplenishmentAmount
          tokenReplenishmentPeriod
          lastReplenishedAt
          updatedAt
          __typename
        }
        serviceId
        service {
          id
          name
          status
          vendor
          region
          endpoint
          body
          header
          projectId
          loadProportion
          inputTokenPricePerMillion
          outputTokenPricePerMillion
          groupId
          createdAt
          updatedAt
          __typename
        }
        requestHash
        messages
        prompt
        response
        tokenCountPrompt
        tokenCountResponse
        createdAt
        hash
        country
        region
        city
        quality
        qualityComment
        apiKeyType
        toxicity
        randomGroup
        agentId
        conversationId
        timings
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    documents {
      items {
        id
        projectId
        agentId
        status
        fileName
        fileSize
        fileType
        uploadDate
        uploader
        lastModifiedDate
        ownershipAttestation
        location
        type
        ragSplitter
        ragChunkSize
        ragChunkOverlap
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    ragQueryLimit
    ragRankLimit
    ragIncludeCitations
    ragDoRerank
    visibility
    createConversationOnFirstChat
    customerEmailCaptureMode
    customerEmailCapturePlaceholder
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMAgentMutationVariables,
  APITypes.UpdateLLMAgentMutation
>;
export const deleteLLMAgent = /* GraphQL */ `mutation DeleteLLMAgent(
  $input: DeleteLLMAgentInput!
  $condition: ModelLLMAgentConditionInput
) {
  deleteLLMAgent(input: $input, condition: $condition) {
    id
    status
    name
    description
    projectId
    systemInstructions
    systemInstructionsAction
    displayTheme
    cssUrl
    displayTitle
    displayStartMessageOrPrompt
    displayInitialMessageOrPrompt
    displayPromptTemplate
    displayFollowOnPrompts
    displayActions
    displayWidth
    displayHeight
    displayPlaceholder
    displayHideInitialPrompt
    displayShowSaveButton
    displayShowEmailButton
    displayShowCallToAction
    displayCallToActionButtonText
    displayCallToActionEmailAddress
    displayCallToActionEmailSubject
    displayCallToActionMustSendEmail
    displayScrollToEnd
    groupId
    data
    calls {
      items {
        id
        projectId
        status
        customerId
        customer {
          id
          name
          status
          tokensRemaining
          lastCallMadeAt
          numberOfCallsMade
          projectId
          loadSheddingTier
          dataResidency
          createdAt
          enterpriseUser
          tokenReplenishmentAmount
          tokenReplenishmentPeriod
          lastReplenishedAt
          updatedAt
          __typename
        }
        serviceId
        service {
          id
          name
          status
          vendor
          region
          endpoint
          body
          header
          projectId
          loadProportion
          inputTokenPricePerMillion
          outputTokenPricePerMillion
          groupId
          createdAt
          updatedAt
          __typename
        }
        requestHash
        messages
        prompt
        response
        tokenCountPrompt
        tokenCountResponse
        createdAt
        hash
        country
        region
        city
        quality
        qualityComment
        apiKeyType
        toxicity
        randomGroup
        agentId
        conversationId
        timings
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    documents {
      items {
        id
        projectId
        agentId
        status
        fileName
        fileSize
        fileType
        uploadDate
        uploader
        lastModifiedDate
        ownershipAttestation
        location
        type
        ragSplitter
        ragChunkSize
        ragChunkOverlap
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    ragQueryLimit
    ragRankLimit
    ragIncludeCitations
    ragDoRerank
    visibility
    createConversationOnFirstChat
    customerEmailCaptureMode
    customerEmailCapturePlaceholder
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMAgentMutationVariables,
  APITypes.DeleteLLMAgentMutation
>;
export const createLLMAgentDocument = /* GraphQL */ `mutation CreateLLMAgentDocument(
  $input: CreateLLMAgentDocumentInput!
  $condition: ModelLLMAgentDocumentConditionInput
) {
  createLLMAgentDocument(input: $input, condition: $condition) {
    id
    projectId
    agentId
    status
    fileName
    fileSize
    fileType
    uploadDate
    uploader
    lastModifiedDate
    ownershipAttestation
    location
    type
    ragSplitter
    ragChunkSize
    ragChunkOverlap
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMAgentDocumentMutationVariables,
  APITypes.CreateLLMAgentDocumentMutation
>;
export const updateLLMAgentDocument = /* GraphQL */ `mutation UpdateLLMAgentDocument(
  $input: UpdateLLMAgentDocumentInput!
  $condition: ModelLLMAgentDocumentConditionInput
) {
  updateLLMAgentDocument(input: $input, condition: $condition) {
    id
    projectId
    agentId
    status
    fileName
    fileSize
    fileType
    uploadDate
    uploader
    lastModifiedDate
    ownershipAttestation
    location
    type
    ragSplitter
    ragChunkSize
    ragChunkOverlap
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMAgentDocumentMutationVariables,
  APITypes.UpdateLLMAgentDocumentMutation
>;
export const deleteLLMAgentDocument = /* GraphQL */ `mutation DeleteLLMAgentDocument(
  $input: DeleteLLMAgentDocumentInput!
  $condition: ModelLLMAgentDocumentConditionInput
) {
  deleteLLMAgentDocument(input: $input, condition: $condition) {
    id
    projectId
    agentId
    status
    fileName
    fileSize
    fileType
    uploadDate
    uploader
    lastModifiedDate
    ownershipAttestation
    location
    type
    ragSplitter
    ragChunkSize
    ragChunkOverlap
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMAgentDocumentMutationVariables,
  APITypes.DeleteLLMAgentDocumentMutation
>;
export const createLLMConversation = /* GraphQL */ `mutation CreateLLMConversation(
  $input: CreateLLMConversationInput!
  $condition: ModelLLMConversationConditionInput
) {
  createLLMConversation(input: $input, condition: $condition) {
    id
    projectId
    agentId
    customerId
    customer {
      id
      name
      status
      tokensRemaining
      lastCallMadeAt
      numberOfCallsMade
      projectId
      loadSheddingTier
      dataResidency
      createdAt
      enterpriseUser
      tokenReplenishmentAmount
      tokenReplenishmentPeriod
      lastReplenishedAt
      updatedAt
      __typename
    }
    createdAt
    status
    title
    summary
    timezone
    language
    country
    region
    city
    calls {
      items {
        id
        projectId
        status
        customerId
        customer {
          id
          name
          status
          tokensRemaining
          lastCallMadeAt
          numberOfCallsMade
          projectId
          loadSheddingTier
          dataResidency
          createdAt
          enterpriseUser
          tokenReplenishmentAmount
          tokenReplenishmentPeriod
          lastReplenishedAt
          updatedAt
          __typename
        }
        serviceId
        service {
          id
          name
          status
          vendor
          region
          endpoint
          body
          header
          projectId
          loadProportion
          inputTokenPricePerMillion
          outputTokenPricePerMillion
          groupId
          createdAt
          updatedAt
          __typename
        }
        requestHash
        messages
        prompt
        response
        tokenCountPrompt
        tokenCountResponse
        createdAt
        hash
        country
        region
        city
        quality
        qualityComment
        apiKeyType
        toxicity
        randomGroup
        agentId
        conversationId
        timings
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    emailAddress
    thumbsupClicked
    thumbsdownClicked
    copyClicked
    emailClicked
    saveClicked
    ctaClicked
    suggestionClicked
    actionClicked
    intelligence
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMConversationMutationVariables,
  APITypes.CreateLLMConversationMutation
>;
export const updateLLMConversation = /* GraphQL */ `mutation UpdateLLMConversation(
  $input: UpdateLLMConversationInput!
  $condition: ModelLLMConversationConditionInput
) {
  updateLLMConversation(input: $input, condition: $condition) {
    id
    projectId
    agentId
    customerId
    customer {
      id
      name
      status
      tokensRemaining
      lastCallMadeAt
      numberOfCallsMade
      projectId
      loadSheddingTier
      dataResidency
      createdAt
      enterpriseUser
      tokenReplenishmentAmount
      tokenReplenishmentPeriod
      lastReplenishedAt
      updatedAt
      __typename
    }
    createdAt
    status
    title
    summary
    timezone
    language
    country
    region
    city
    calls {
      items {
        id
        projectId
        status
        customerId
        customer {
          id
          name
          status
          tokensRemaining
          lastCallMadeAt
          numberOfCallsMade
          projectId
          loadSheddingTier
          dataResidency
          createdAt
          enterpriseUser
          tokenReplenishmentAmount
          tokenReplenishmentPeriod
          lastReplenishedAt
          updatedAt
          __typename
        }
        serviceId
        service {
          id
          name
          status
          vendor
          region
          endpoint
          body
          header
          projectId
          loadProportion
          inputTokenPricePerMillion
          outputTokenPricePerMillion
          groupId
          createdAt
          updatedAt
          __typename
        }
        requestHash
        messages
        prompt
        response
        tokenCountPrompt
        tokenCountResponse
        createdAt
        hash
        country
        region
        city
        quality
        qualityComment
        apiKeyType
        toxicity
        randomGroup
        agentId
        conversationId
        timings
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    emailAddress
    thumbsupClicked
    thumbsdownClicked
    copyClicked
    emailClicked
    saveClicked
    ctaClicked
    suggestionClicked
    actionClicked
    intelligence
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMConversationMutationVariables,
  APITypes.UpdateLLMConversationMutation
>;
export const deleteLLMConversation = /* GraphQL */ `mutation DeleteLLMConversation(
  $input: DeleteLLMConversationInput!
  $condition: ModelLLMConversationConditionInput
) {
  deleteLLMConversation(input: $input, condition: $condition) {
    id
    projectId
    agentId
    customerId
    customer {
      id
      name
      status
      tokensRemaining
      lastCallMadeAt
      numberOfCallsMade
      projectId
      loadSheddingTier
      dataResidency
      createdAt
      enterpriseUser
      tokenReplenishmentAmount
      tokenReplenishmentPeriod
      lastReplenishedAt
      updatedAt
      __typename
    }
    createdAt
    status
    title
    summary
    timezone
    language
    country
    region
    city
    calls {
      items {
        id
        projectId
        status
        customerId
        customer {
          id
          name
          status
          tokensRemaining
          lastCallMadeAt
          numberOfCallsMade
          projectId
          loadSheddingTier
          dataResidency
          createdAt
          enterpriseUser
          tokenReplenishmentAmount
          tokenReplenishmentPeriod
          lastReplenishedAt
          updatedAt
          __typename
        }
        serviceId
        service {
          id
          name
          status
          vendor
          region
          endpoint
          body
          header
          projectId
          loadProportion
          inputTokenPricePerMillion
          outputTokenPricePerMillion
          groupId
          createdAt
          updatedAt
          __typename
        }
        requestHash
        messages
        prompt
        response
        tokenCountPrompt
        tokenCountResponse
        createdAt
        hash
        country
        region
        city
        quality
        qualityComment
        apiKeyType
        toxicity
        randomGroup
        agentId
        conversationId
        timings
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    emailAddress
    thumbsupClicked
    thumbsdownClicked
    copyClicked
    emailClicked
    saveClicked
    ctaClicked
    suggestionClicked
    actionClicked
    intelligence
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMConversationMutationVariables,
  APITypes.DeleteLLMConversationMutation
>;
export const createLLMModel = /* GraphQL */ `mutation CreateLLMModel(
  $input: CreateLLMModelInput!
  $condition: ModelLLMModelConditionInput
) {
  createLLMModel(input: $input, condition: $condition) {
    id
    status
    vendor
    host
    supported
    name
    description
    modelKey
    modelKeyLatest
    inputTokenPrice
    cachedTokenPrice
    outputTokenPrice
    inputTokenBatchPrice
    outputTokenBatchPrice
    searchCost
    textInputSupport
    imageInputSupport
    audioInputSupport
    textOutputSupport
    imageOutputSupport
    audioOutputSupport
    thinkingSupport
    contextWindowTokens
    maxResponseTokens
    knowledgeCutoffDate
    lastCheckedDate
    supportedLanguages
    warningDate
    warningMessage
    deprecationDate
    deprecationMessage
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLLMModelMutationVariables,
  APITypes.CreateLLMModelMutation
>;
export const updateLLMModel = /* GraphQL */ `mutation UpdateLLMModel(
  $input: UpdateLLMModelInput!
  $condition: ModelLLMModelConditionInput
) {
  updateLLMModel(input: $input, condition: $condition) {
    id
    status
    vendor
    host
    supported
    name
    description
    modelKey
    modelKeyLatest
    inputTokenPrice
    cachedTokenPrice
    outputTokenPrice
    inputTokenBatchPrice
    outputTokenBatchPrice
    searchCost
    textInputSupport
    imageInputSupport
    audioInputSupport
    textOutputSupport
    imageOutputSupport
    audioOutputSupport
    thinkingSupport
    contextWindowTokens
    maxResponseTokens
    knowledgeCutoffDate
    lastCheckedDate
    supportedLanguages
    warningDate
    warningMessage
    deprecationDate
    deprecationMessage
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLLMModelMutationVariables,
  APITypes.UpdateLLMModelMutation
>;
export const deleteLLMModel = /* GraphQL */ `mutation DeleteLLMModel(
  $input: DeleteLLMModelInput!
  $condition: ModelLLMModelConditionInput
) {
  deleteLLMModel(input: $input, condition: $condition) {
    id
    status
    vendor
    host
    supported
    name
    description
    modelKey
    modelKeyLatest
    inputTokenPrice
    cachedTokenPrice
    outputTokenPrice
    inputTokenBatchPrice
    outputTokenBatchPrice
    searchCost
    textInputSupport
    imageInputSupport
    audioInputSupport
    textOutputSupport
    imageOutputSupport
    audioOutputSupport
    thinkingSupport
    contextWindowTokens
    maxResponseTokens
    knowledgeCutoffDate
    lastCheckedDate
    supportedLanguages
    warningDate
    warningMessage
    deprecationDate
    deprecationMessage
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLLMModelMutationVariables,
  APITypes.DeleteLLMModelMutation
>;
